import React from 'react';

const Background = (props) => (
  <div className="searchStrutture-background" {...props} />
);

export default Background;
